import React, { useEffect } from 'react';

import FroalaEditor from 'react-froala-wysiwyg';
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/print.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/url.min.js';


import "./Notes.styles.sass";

type NotesProps = {
  text: string,
  readOnly?: boolean,
  onChange?: (event: any) => void,
  classname?: string,
  kill?: boolean
}

const config = {
  key: null,
  pluginsEnabled: ['table', 'print', 'quote', 'link', 'lists', 'image', 'fontSize', 'paragraphFormat', 'url'],
  toolbarButtons: {
    moreText: {
      buttons: ['fontSize', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle']
    },
    moreParagraph: {
      buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
    },
    moreRich: {
      buttons: ['insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertImage', 'insertVideo', 'insertLink', 'insertFile'],
      'buttonsVisible': 3
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'html', 'help'], //add 'getPDF', when BE will be ready with export to PDF
      'align': 'right',
      'buttonsVisible': 4
    }
  },
  linkAlwaysBlank: true,
  imageAllowedTypes: ['jpeg', 'jpg', 'png']
};


const isDev = (location.host == "localhost:8000" || (location.host.split(".").length == 4));

if (!isDev)
  config.key = "zEG4iB3A9D6A4F5D4A4H3JzrlD-13TMIBDIa2NTMNZFFPFZe2a1Id1f1I1fA8D6C4A4G3H3F2A18A15A7==";

export const Notes = ({text = '', readOnly, onChange, classname, kill}: NotesProps) => {
  const inputHandler = (data) => onChange(data);
  const handleMouseDown = (event: MouseEvent & { target: HTMLLinkElement}) => {
    const target = event.target;

    if (target && target.localName && target.href && target.href !== "") {
      event.preventDefault();
      window.open(target.href, '_blank');
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);

  useEffect(() => {
    if (kill) {
      document.removeEventListener("mousedown", handleMouseDown);
    }
  }, [kill]);

  return (
    <div className={classname}>
      <div className='editorWrapper'>
        {readOnly
          ? <div>
              <FroalaEditor
                tag="textarea"
                config={{
                  ...config,
                  toolbarButtons: {},
                  events: {
                    initialized() {
                      this.edit.off();
                    }
                  }
                }}
                model={text}
              />
            </div>
          : <FroalaEditor
              tag="textarea"
              config={{
                ...config,
                events: {
                  'image.beforeUpload': function handleImageUpload(files) {
                    const editor = this;

                    if (files.length) {
                      const reader = new FileReader();
                      reader.onload = function(e) {
                        const result = e.target.result;
                        editor.image.insert(result, null, null, editor.image.get());
                      };

                      reader.readAsDataURL(files[0]);
                    }

                    editor.popups.hideAll();
                    return false;
                  },
                  'paste.beforeCleanup': function (clipboard) {
                    return '<p>' + clipboard.replace(/<br>/gi, "\n") + '</p>';
                  }
                }
              }}
              model={text}
              onModelChange={inputHandler}
            />
        }
      </div>
    </div>
  );
};
